import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { CamundaFacadeService } from '../camunda-facade.service';

@Component({
  selector: 'app-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.scss'] 
})
export class NotificationComponent {
  @Input() showNotification: boolean = false;

  constructor(private router: Router, private camundaFacadeService: CamundaFacadeService) {}

  closeNotification(): void {
    this.showNotification = false;
  }

  navigateToPending(): void {
    this.camundaFacadeService.allowPendingAccess = true;
    this.router.navigate(['/camunda/pending']);
  }
}